/* ============================================================================
   Upsell popup after add-to-cart (merchant 2026-10-03)

   Opens INSTEAD of the cart drawer after
     · an add from the flavour selectors — snippets/multi-flavour-selector-v5.liquid (2L pages) and
       snippets/jb-multi-flavour-selector-limited-vip-2026.liquid call
       JBUpsell.afterAdd({ items, cart, source: 'selector' }).then(openCartDrawer)
     · a set add — every bundle-product-form picker goes through the theme's variant:add; a capture-phase listener
       below sets detail.blockCartDrawerOpening (the theme's own flag, see CartDrawer._onVariantAdded in theme.js),
       shows the popup and opens the drawer afterwards. Mix & Match (_bundleTitle) is left alone: it has its own
       popup before the add.
   Max. 3 suggestions at normal price, chosen per cart. Accessories carry the margin (merchant 2026-10-04), so:
     1. reward nudge — only if the section switch "Boxen … vorschlagen" is on (default OFF), only while the launch
        campaign runs and only after selector adds: if 1–2 single boxes are
        missing to the next reward — VIP-Socken at 4 (in stock) or the next free box at a multiple of 6 — that many
        flavour cards from the same family (Limited ↔ 2L) and the same line (Light/Original), favourites first;
     2. accessories from the "Upsell-Popup" section blocks, in block order (ranked by profit), minus what is already
        in the cart or in a set in the cart, sold-out ones and those whose "ab X Boxen" is not reached; at most one
        per "Gruppe" (none if the group is already in the cart); products shown earlier in the session without
        being taken move to the back (rotation, sessionStorage jbUpsSeen).
   Nothing to suggest, popup off, or 2 × "Nein danke" in this session → no popup, the drawer opens as before.
   X+1 offers: an accessory block may add several per click ("Menge pro Klick") with some free ("davon gratis") —
   the bottle adds 3 and the live automatic discount "2+1 GRATIS" makes one free; the card shows "3×" and the paid price.
   Theme editor (Shopify.designMode): the real flow, on EVERY add — no 2× "Nein danke" limit, declines are not
   counted, no analytics events. A settings change (section re-render) is picked up by the next add.
   FIXED TRIO (merchant 2026-10-09, section switch "Festes Trio", on): instead of the reward nudge and the accessory
   list, always Karaffenset · Premium Cup (Schwarz first = preselected) · ONE Genussbox chosen from the boxes in the
   cart (≥ trio.min_boxes boxes and ≥ trio.share % of them Limited → the Limited Genussbox of the line picked more,
   tie → Light; otherwise the Genussbox Bonus Set). What is already in the cart or in a set is left out. Inside the
   discount window (trio.discount.from/to — the same window as the automatic discount in the admin) the cards show
   "−20 %", the price struck through, and the badge above them.
   Data: #jb-ups-config from sections/jb-upsell-popup.liquid. Measurement: Shopify.analytics.publish('jb_upsell_*').
   ========================================================================== */
(function () {
  'use strict';

  if (window.JBUpsell) return;

  var DECLINE_KEY = 'jbUpsDeclines';
  var SEEN_KEY = 'jbUpsSeen';
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var HEADERS = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  var STAR = '<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"/></svg>';
  var GIFT = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8"/><path d="M16.5 8a2.5 2.5 0 0 0 0-5C13 3 12 8 12 8"/></svg>';
  var CHECK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var PLUS = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>';

  var SPIN = '<span class="jb-ups__spinner" aria-hidden="true"></span>';

  var cfg = null;
  function config() {
    if (cfg) return cfg;
    var el = document.getElementById('jb-ups-config');
    if (!el) return null;
    try { cfg = JSON.parse(el.textContent); } catch (err) { cfg = null; }
    if (cfg) {
      cfg._boxProducts = {};
      (cfg.box_product_ids || []).forEach(function (id) { cfg._boxProducts[String(id)] = true; });
      cfg._boxVariants = {};
      (cfg.box_variant_ids || []).forEach(function (id) { cfg._boxVariants[String(id)] = true; });
    }
    return cfg;
  }

  function editor() { return !!(window.Shopify && window.Shopify.designMode); }
  // smart frequency: 2 × "Nein danke" per session ends it — except in the theme editor, where it shows every time
  function capped() { return !editor() && declines() >= 2; }

  function publish(name, data) {
    if (editor()) return;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (err) { /* ignore */ }
  }
  function declines() { try { return Number(sessionStorage.getItem(DECLINE_KEY) || 0); } catch (err) { return 0; } }
  function addDecline() { try { sessionStorage.setItem(DECLINE_KEY, String(declines() + 1)); } catch (err) { /* ignore */ } }
  function seen() { try { return JSON.parse(sessionStorage.getItem(SEEN_KEY) || '{}') || {}; } catch (err) { return {}; } }
  function markSeen(ids) {
    if (editor() || !ids.length) return; // the editor shows the block order as it is
    try { var m = seen(); ids.forEach(function (id) { m[String(id)] = 1; }); sessionStorage.setItem(SEEN_KEY, JSON.stringify(m)); } catch (err) { /* ignore */ }
  }
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // "EISTEE PFIRSICH LIGHT" → "Eistee Pfirsich Light" (variant titles are ALL CAPS)
  function titleCase(s) {
    return String(s || '').toLowerCase().replace(/(^|[\s\-(])(\S)/g, function (m, a, b) { return a + b.toUpperCase(); });
  }

  function flavourKey(t) { return String(t || '').split(' (')[0].trim().toUpperCase(); }

  function fetchCart() { return fetch(routeRoot + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  function components(item) {
    var raw = item.properties && item.properties._bundleComponents;
    if (!raw) return [];
    try { var list = typeof raw === 'string' ? JSON.parse(raw) : raw; return Array.isArray(list) ? list : []; } catch (err) { return []; }
  }

  // Single boxes (5+1 / socks) and boxes inside sets (only for "ab X Boxen") — the cart bar's rules.
  function counts(cart) {
    var c = config(), single = 0, inSets = 0;
    ((cart && cart.items) || []).forEach(function (item) {
      var p = item.properties || {};
      if (p._jb_promo || p._jb_gift) return;
      if (c._boxProducts[String(item.product_id)]) {
        if (p._bundle_id) inSets += item.quantity; else single += item.quantity;
        return;
      }
      components(item).forEach(function (comp) {
        if (c._boxVariants[String(comp.id)]) inSets += (Number(comp.quantity) || 1) * item.quantity;
      });
    });
    return { single: single, all: single + inSets };
  }

  // Next campaign reward for the single-box count t: { gap, kind: 'socks'|'box', at }
  function nextReward(t) {
    var c = config();
    if (!c.campaign) return null;
    if (c.socks && t < 4) return { gap: 4 - t, kind: 'socks', at: 4 };
    var inCycle = t % 6;
    var gap = inCycle === 0 ? 6 : 6 - inCycle;
    return { gap: gap, kind: 'box', at: t + gap };
  }

  function familyOf(items) {
    var limited = 0, std = 0;
    (items || []).forEach(function (i) {
      if (String(i.product_id) === '7176558280869') limited += i.quantity; else if (config()._boxProducts[String(i.product_id)]) std += i.quantity;
    });
    if (!limited && !std) return null;
    return limited >= std ? 'limited' : 'standard';
  }

  function lineOf(items, pool) {
    var byId = {}, light = 0, orig = 0;
    pool.forEach(function (f) { byId[String(f.id)] = f; });
    (items || []).forEach(function (i) {
      var f = byId[String(i.variant_id || i.id)];
      if (!f) return;
      if (f.line === 'light') light += i.quantity; else orig += i.quantity;
    });
    if (!light && !orig) return null;
    return light >= orig ? 'light' : 'original';
  }

  // trio discount: only inside its window (epoch seconds)
  function trioPct() {
    var t = config().trio, d = t && t.discount;
    if (!d || !(d.pct > 0)) return 0;
    var now = Date.now() / 1000;
    if (d.from && now < d.from) return 0;
    if (d.to && now >= d.to) return 0;
    return d.pct;
  }

  // the Genussbox for this cart: many boxes, mostly Limited → Limited Genussbox (Light/Original by majority)
  function genussFor(cart) {
    var c = config(), t = c.trio, all = 0, ltd = 0, light = 0, orig = 0;
    var pool = {};
    ((c.flavours && c.flavours.limited) || []).forEach(function (f) { pool[String(f.id)] = f.line; });
    ((cart && cart.items) || []).forEach(function (item) {
      var p = item.properties || {};
      if (p._jb_promo || p._jb_gift) return;
      if (c._boxProducts[String(item.product_id)]) {
        all += item.quantity;
        if (String(item.product_id) === '7176558280869') {
          ltd += item.quantity;
          var line = pool[String(item.variant_id)] || (/light/i.test(item.variant_title || item.title || '') ? 'light' : 'original');
          if (line === 'light') light += item.quantity; else orig += item.quantity;
        }
        return;
      }
      components(item).forEach(function (comp) { if (c._boxVariants[String(comp.id)]) all += (Number(comp.quantity) || 1) * item.quantity; });
    });
    var limitedFan = all >= (t.min_boxes || 4) && ltd * 100 >= (t.share || 75) * all;
    if (limitedFan) {
      var first = light >= orig ? 'ltd_light' : 'ltd_original', second = first === 'ltd_light' ? 'ltd_original' : 'ltd_light';
      // the free Limited Genussbox Light (cart-gift box tier, from N single boxes) comes anyway — never sell the
      // same line on top: offer Original instead (the gift line may not be in the cart yet right after the add)
      if (first === 'ltd_light' && giftLightComing(cart)) { first = 'ltd_original'; second = null; }
      return t[first] || (second && t[second]) || t.bonus;
    }
    return t.bonus || null;
  }

  function giftLightComing(cart) {
    var t = config().trio, gv = String(t.gift_light_variant || ''), from = Number(t.gift_light_from) || 0;
    if (!gv) return false;
    var single = 0, has = false;
    ((cart && cart.items) || []).forEach(function (item) {
      var p = item.properties || {};
      if (String(item.variant_id) === gv) has = true;
      if (p._jb_promo || p._jb_gift || p._bundle_id || p._bundleComponents) return;
      if (config()._boxProducts[String(item.product_id)]) single += item.quantity;
    });
    return has || (from > 0 && single >= from);
  }

  function trioSuggestions(ctx) {
    var c = config(), t = c.trio, out = [], pct = trioPct();
    var inCart = {}, inSets = {};
    (ctx.cart.items || []).forEach(function (item) {
      var p = item.properties || {};
      if (!p._jb_gift && !p._jb_promo) inCart[String(item.product_id)] = true;
      components(item).forEach(function (comp) { inSets[String(comp.id)] = true; });
    });
    function owned(prod) {
      if (inCart[String(prod.product_id)]) return true;
      return (prod.variants || []).some(function (v) { return inSets[String(v.id)]; });
    }
    // slot 3 is ONE Genussbox: if any of them (Bonus Set or Limited, bought — not the free cart gift) is already in
    // the cart or in a set, no second one is offered, even when the cart now points to the other kind
    var genussIds = [t.bonus, t.ltd_light, t.ltd_original].filter(Boolean);
    var hasGenuss = genussIds.some(owned);
    [t.carafe, t.cup, hasGenuss ? null : genussFor(ctx.cart)].forEach(function (prod) {
      if (!prod || !prod.variants || !prod.variants.length || owned(prod)) return;
      var v0 = prod.variants[0];
      out.push({
        // one fixed variant (the Genussboxen): its title is the hint ("Light - 10 Proben")
        kind: 'trio', title: String(prod.title || '').replace(/^\s*JuiceBox\s*™?\s*/i, ''), hint: prod.variants.length === 1 && !/default title/i.test(v0.title) ? esc(v0.title) : '', image: v0.image || prod.image, // the preselected variant's own picture (Premium Cup: the black one)
        variants: prod.variants, product_id: prod.product_id, qty: 1, free: 0, discount: 0, pct: pct
      });
    });
    return out;
  }

  function suggestions(ctx) {
    var c = config(), out = [];
    if (c.trio) return trioSuggestions(ctx);
    var inCart = {}, inCartVariants = {}, inSets = {}, inCartFlavours = {};
    (ctx.cart.items || []).forEach(function (item) {
      inCart[String(item.product_id)] = true;
      inCartVariants[String(item.variant_id)] = true;
      // flavour names too: the same flavour can come from another box product (juicebox-light / juicebox)
      if (c._boxProducts[String(item.product_id)] && item.variant_title) inCartFlavours[flavourKey(item.variant_title)] = true;
      components(item).forEach(function (comp) { inSets[String(comp.id)] = true; });
    });
    var n = counts(ctx.cart);

    // 1. reward nudge — flavour boxes
    if (ctx.source === 'selector' && c.boxes) {
      var r = nextReward(n.single);
      if (r && r.gap <= 2) {
        var fam = familyOf(ctx.items);
        var pool = fam ? (c.flavours[fam] || []) : [];
        var line = lineOf(ctx.items, pool);
        var picks = pool
          .filter(function (f) { return !inCartVariants[String(f.id)] && !inCartFlavours[flavourKey(f.title)]; })
          .map(function (f, idx) { return { f: f, score: (line && f.line === line ? 0 : 10) + (f.top ? 0 : 1), idx: idx }; })
          .sort(function (a, b) { return a.score - b.score || a.idx - b.idx; })
          .slice(0, r.gap)
          .map(function (x) { return x.f; });
        picks.forEach(function (f) {
          out.push({
            kind: 'flavour',
            title: titleCase(f.title),
            hint: (f.top ? '<span class="jb-ups__tag">' + STAR + (fam === 'limited' ? 'Fan-Liebling' : 'Bestseller') + '</span> · ' : '') + (f.line === 'light' ? 'Light' : 'Original'),
            image: f.image,
            variants: [{ id: f.id, title: '', price: f.price, compare: f.compare }]
          });
        });
      }
    }

    // 2. accessories — block order = priority (ranked by profit), with groups and rotation
    function owned(a) {
      if (inCart[String(a.product_id)]) return true;
      if ((a.variants || []).some(function (v) { return inSets[String(v.id)]; })) return true;
      // "Nicht zeigen, wenn …" — twins that already cover it, as a cart line or inside a set
      if ((a.covered_products || []).some(function (id) { return inCart[String(id)]; })) return true;
      return (a.covered_variants || []).some(function (id) { return inSets[String(id)] || inCartVariants[String(id)]; });
    }
    var accs = c.accessories || [];
    var groupOwned = {}, groupUsed = {};
    accs.forEach(function (a) { if (a.group && owned(a)) groupOwned[a.group] = true; });
    var seenMap = editor() ? {} : seen();
    accs
      .map(function (a, idx) { return { a: a, idx: idx, seen: seenMap[String(a.product_id)] ? 1 : 0 }; })
      .sort(function (x, y) { return x.seen - y.seen || x.idx - y.idx; })
      .forEach(function (x) {
        var a = x.a;
        if (out.length >= 3) return;
        if (!a.variants || !a.variants.length) return;
        if (owned(a)) return;
        if (a.group && (groupOwned[a.group] || groupUsed[a.group])) return;
        if (n.all < (a.min_boxes || 0)) return;
        var qty = Math.max(1, Number(a.qty) || 1);
        out.push({
          kind: 'accessory', title: (qty > 1 ? qty + '× ' : '') + a.title, hint: esc(a.hint || ''), image: a.image,
          variants: a.variants, product_id: a.product_id, qty: qty,
          free: Math.min(Math.max(0, Number(a.free) || 0), qty - 1), discount: Math.max(0, Number(a.discount) || 0)
        });
        if (a.group) groupUsed[a.group] = true;
      });
    return out.slice(0, 3);
  }

  // Price for "qty per click, `free` of them free": the paid ones, struck through against all at the normal price.
  // Without free ones: qty × price, struck through against qty × compare-at (if higher).
  // With a fixed discount for the quantity ("3er Rabatt"): qty × price − discount, struck through against qty × price.
  function priceHtml(s, price, compare) {
    var qty = s.qty || 1, free = s.free || 0, discount = s.discount || 0;
    // trio inside the discount window: −pct %, struck through against the normal price
    if (s.pct) {
      var cut = Math.round(price * (100 - s.pct) / 100);
      return money(cut * qty) + ' <s>' + money(price * qty) + '</s> <span class="jb-ups__off">−' + s.pct + '%</span>';
    }
    var now = discount ? Math.max(0, price * qty - discount) : price * (qty - free);
    var was = (free || discount) ? price * qty : (compare > price ? compare * qty : 0);
    return money(now) + (was > now ? ' <s>' + money(was) + '</s>' : '');
  }

  function cardHtml(s, i) {
    var v = s.variants[0];
    var select = s.variants.length > 1
      ? '<select class="jb-ups__variant" data-ups-variant aria-label="Variante wählen">' + s.variants.map(function (x) {
          return '<option value="' + x.id + '" data-price="' + x.price + '" data-compare="' + x.compare + '"' + (x.image ? ' data-image="' + esc(x.image) + '"' : '') + '>' + esc(x.title) + '</option>';
        }).join('') + '</select>'
      : '';
    var price = '<span class="jb-ups__price" data-ups-price>' + priceHtml(s, v.price, v.compare) + '</span>';
    return '<div class="jb-ups__card" data-ups-card="' + i + '">' +
      (s.image ? '<img class="jb-ups__img" src="' + esc(s.image) + '" alt="" loading="eager" width="64" height="64">' : '<span class="jb-ups__img"></span>') +
      '<div class="jb-ups__info"><p class="jb-ups__name">' + esc(s.title) + '</p>' +
      (s.hint ? '<p class="jb-ups__hint">' + s.hint + '</p>' : '') + price + select + '</div>' +
      '<button type="button" class="jb-ups__add" data-ups-add="' + i + '">' + PLUS + '<span class="jb-ups__add-label">Hinzufügen</span></button>' +
      '</div>';
  }

  var state = null; // { resolve, added, suggestions, ctx }

  function render(ctx, list) {
    var dlg = document.getElementById('jb-ups');
    var c = config();
    // what was just added: the selector's request — /cart/add.js answers with the merged line (2 Eistee in the cart
    // + 1 more → quantity 3), so data.items would overstate it
    var added = (ctx.requested || ctx.items || []).reduce(function (n, i) { return n + (Number(i.quantity) || 0); }, 0);
    var title;
    if (ctx.source === 'set') {
      var setItem = (ctx.items || []).filter(function (i) { return i.properties && i.properties._bundleComponents; })[0];
      title = esc((setItem && (setItem.product_title || setItem.title)) || 'Dein Set') + ' hinzugefügt';
    } else {
      title = (added === 1 ? '1 Box' : added + ' Boxen') + ' hinzugefügt';
    }
    dlg.querySelector('[data-ups-title]').innerHTML = title;
    dlg.querySelector('[data-ups-heading]').textContent = c.texts.heading;
    var badge = dlg.querySelector('[data-ups-badge]'), pct = c.trio ? trioPct() : 0;
    if (badge) {
      badge.hidden = !pct;
      badge.textContent = pct ? (c.trio.discount.badge ? c.trio.discount.badge + ' · ' : '') + pct + '% Rabatt' : ''; // "Nur für VIPs · 20% Rabatt" (merchant)
    }
    dlg.querySelector('[data-ups-continue]').textContent = c.texts.continue;
    dlg.querySelector('[data-ups-decline]').textContent = c.texts.decline;
    dlg.querySelector('[data-ups-list]').innerHTML = list.map(cardHtml).join('');
    updateNudge(ctx.cart);
  }

  function updateNudge(cart) {
    var dlg = document.getElementById('jb-ups');
    var el = dlg.querySelector('[data-ups-nudge]');
    if (!state || state.ctx.source !== 'selector' || !config().campaign || !config().boxes) { el.hidden = true; return; }
    var c = config();
    var t = counts(cart).single;
    var r = nextReward(t);
    var boxes = function (n) { return n === 1 ? '1 Box' : n + ' Boxen'; };
    // a reward reached while the popup is open is celebrated first (socks at 4, a free box at every 6th)
    var reached = '';
    if (state.lastT != null && t > state.lastT) {
      if (c.socks && state.lastT < 4 && t >= 4) reached = 'VIP-Socken gesichert!';
      if (Math.floor(t / 6) > Math.floor(state.lastT / 6)) reached = 'Deine ' + (Math.floor(t / 6) * 6) + '. Box ist gratis!';
    }
    state.lastT = t;
    var next = '';
    if (r && r.gap <= 2) {
      next = r.kind === 'socks'
        ? 'Noch <strong>' + boxes(r.gap) + '</strong> – dann legen wir dir die VIP-Socken gratis dazu.'
        : 'Noch <strong>' + boxes(r.gap) + '</strong> – dann ist deine <strong>' + r.at + '. Box gratis</strong>.';
    }
    if (reached) {
      el.classList.add('is-done');
      el.innerHTML = CHECK + '<span><strong>' + reached + '</strong>' + (next ? ' ' + next : '') + '</span>';
      el.hidden = false;
    } else if (next) {
      el.classList.remove('is-done');
      el.innerHTML = GIFT + '<span>' + next + '</span>';
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function close(reason) {
    if (!state) return;
    var dlg = document.getElementById('jb-ups');
    var s = state;
    state = null;
    if (reason === 'decline' && !s.added && !editor()) addDecline();
    publish('jb_upsell_close', { reason: reason, added: s.added, source: s.ctx.source });
    try { dlg.close(); } catch (err) { dlg.removeAttribute('open'); }
    document.documentElement.classList.remove('jb-ups-lock');
    if (s.added) document.dispatchEvent(new CustomEvent('cart:refresh'));
    s.resolve();
  }

  function addFromCard(i, btn) {
    if (!state || btn.classList.contains('is-busy') || btn.classList.contains('is-added')) return;
    var s = state.suggestions[i];
    var card = btn.closest('[data-ups-card]');
    var sel = card && card.querySelector('[data-ups-variant]');
    var variantId = sel ? Number(sel.value) : Number(s.variants[0].id);
    // every line from the popup is marked, like the cart gifts' _jb_gift: hidden from the customer, visible on the
    // order in the admin (line item properties) — accessories and flavour boxes alike
    var item = { id: variantId, quantity: s.qty || 1, properties: { _jb_upsell: 'popup' } };
    btn.style.width = btn.offsetWidth + 'px'; // the spinner replaces the content at the same size
    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-label', 'Wird hinzugefügt');
    btn.innerHTML = SPIN;
    fetch(routeRoot + 'cart/add.js', { method: 'POST', headers: HEADERS, credentials: 'same-origin', body: JSON.stringify({ items: [item] }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('aria-label');
        btn.style.width = '';
        btn.classList.add('is-added');
        btn.innerHTML = CHECK + '<span class="jb-ups__add-label">Hinzugefügt</span>';
        if (state) state.added += 1;
        publish('jb_upsell_add', { kind: s.kind, variant_id: variantId, quantity: item.quantity, title: s.title });
        return fetchCart().then(function (cart) { if (state) updateNudge(cart); });
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('aria-label');
        btn.style.width = '';
        btn.innerHTML = '<span>Nicht verfügbar</span>';
        btn.disabled = true;
      });
  }

  function bind() {
    var dlg = document.getElementById('jb-ups');
    if (!dlg || dlg.__jbUpsBound) return;
    dlg.__jbUpsBound = true;
    dlg.addEventListener('click', function (e) {
      var t = e.target;
      if (t === dlg) { close(state && state.added ? 'continue' : 'decline'); return; } // backdrop
      var add = t.closest('[data-ups-add]');
      if (add) { addFromCard(Number(add.getAttribute('data-ups-add')), add); return; }
      if (t.closest('[data-ups-continue]')) { close('continue'); return; }
      if (t.closest('[data-ups-decline]')) { close('decline'); return; }
      if (t.closest('[data-ups-close]')) { close(state && state.added ? 'continue' : 'decline'); }
    });
    dlg.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-ups-variant]');
      if (!sel) return;
      var o = sel.options[sel.selectedIndex];
      var price = Number(o.getAttribute('data-price')), compare = Number(o.getAttribute('data-compare'));
      var card = sel.closest('[data-ups-card]');
      var s = state && state.suggestions[Number(card.getAttribute('data-ups-card'))];
      card.querySelector('[data-ups-price]').innerHTML = priceHtml(s || {}, price, compare);
      // the colour's own picture (Premium Cup Schwarz / Weiß / Beige)
      var img = card.querySelector('img.jb-ups__img'), src = o.getAttribute('data-image');
      if (img && src) img.src = src;
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(state && state.added ? 'continue' : 'decline'); }); // Esc
  }

  // Public: resolves when the customer is done (or right away when nothing should show).
  function afterAdd(opts) {
    return new Promise(function (resolve) {
      try {
        var c = config();
        var dlg = document.getElementById('jb-ups');
        if (!opts || !opts.cart || !c || !dlg || state || capped()) { resolve(); return; }
        var ctx = { items: opts.items || [], requested: opts.requested || null, cart: opts.cart, source: opts.source || 'selector' };
        var list = suggestions(ctx);
        if (!list.length) { resolve(); return; }
        bind();
        state = { resolve: resolve, added: 0, suggestions: list, ctx: ctx, lastT: null };
        render(ctx, list);
        document.documentElement.classList.add('jb-ups-lock');
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        markSeen(list.filter(function (x) { return x.kind === 'accessory'; }).map(function (x) { return x.product_id; }));
        publish('jb_upsell_shown', { source: ctx.source, count: list.length, kinds: list.map(function (s) { return s.kind; }).join(',') });
      } catch (err) {
        console.error('[jb-upsell]', err);
        state = null;
        document.documentElement.classList.remove('jb-ups-lock');
        resolve();
      }
    });
  }

  window.JBUpsell = { afterAdd: afterAdd };

  // The pictures would only start loading when the popup opens (a moment of empty boxes) — warm the cache once the
  // page is idle. 200 px WebP each, at most 16.
  function preloadImages() {
    var c = config();
    if (!c) return;
    var imgs = (c.accessories || []).map(function (a) { return a.image; });
    if (c.trio) ['carafe', 'cup', 'bonus', 'ltd_light', 'ltd_original'].forEach(function (k) {
      var p = c.trio[k];
      if (p) { imgs.push(p.image); (p.variants || []).forEach(function (v) { imgs.push(v.image); }); }
    });
    imgs.filter(Boolean).forEach(function (src) { var img = new Image(); img.decoding = 'async'; img.src = src; });
  }
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 2500); };
  if (document.readyState === 'complete') idle(preloadImages);
  else window.addEventListener('load', function () { idle(preloadImages); });

  // Theme editor: a settings change re-renders the section — read the new config on the next add, and let go of a
  // popup whose dialog was just replaced (otherwise `state` would block every later add).
  if (editor()) {
    document.addEventListener('shopify:section:load', function (e) {
      if (!(e.target && e.target.querySelector && e.target.querySelector('#jb-ups'))) return;
      cfg = null;
      if (state) { var old = state; state = null; document.documentElement.classList.remove('jb-ups-lock'); old.resolve(); }
    });
  }

  // Sets: every bundle-product-form picker ends in the theme's variant:add. Catch it before the drawer does.
  document.addEventListener('variant:add', function (event) {
    var d = event.detail || {};
    var items = d.items || [];
    var isSet = items.some(function (i) { return i.properties && i.properties._bundleComponents && !i.properties._bundleTitle; });
    if (!isSet || !config() || !document.getElementById('jb-ups') || state || capped()) return;
    var cart = d.cart;
    var ctx = { items: items, cart: cart, source: 'set' };
    if (!cart || !cart.items || !suggestions(ctx).length) return; // nothing to offer → theme opens the drawer
    d.blockCartDrawerOpening = true;
    afterAdd(ctx).then(function () {
      var drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.show === 'function') drawer.show(); else if (drawer) drawer.setAttribute('open', '');
    });
  }, true);
})();
